export default __webpack_public_path__ + "static/media/l2.98d220b0.png";